import { render, staticRenderFns } from "./UsageDetailPerformance.vue?vue&type=template&id=5042423e&scoped=true&"
import script from "./UsageDetailPerformance.vue?vue&type=script&lang=js&"
export * from "./UsageDetailPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042423e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5042423e')) {
      api.createRecord('5042423e', component.options)
    } else {
      api.reload('5042423e', component.options)
    }
    module.hot.accept("./UsageDetailPerformance.vue?vue&type=template&id=5042423e&scoped=true&", function () {
      api.rerender('5042423e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagedetailperformance/UsageDetailPerformance.vue"
export default component.exports